module.exports = __webpack_public_path__ + "static/media/zvonko-bitenc-s.ec5640c2.webp";